import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import "../../../assets/css/customer/dashboard/CustomerBlog.css";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";
import { Navigate, useNavigate } from "react-router-dom";

/* ── Heart Icon ── */
const SgcHeartIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="16"
    height="16"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

/* ── 4 Blog Posts ── */
const blogPosts = [
  {
    id: 1,
    date: "May 02, 2026",
    readTime: "4 min read",
    title: "5 Skincare Basics Every Customer Should Follow",
    excerpt:
      "Cleanse, treat, hydrate, protect — the routine our dermatologists recommend.",
    img: "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=600&q=80",
  },
  {
    id: 2,
    date: "Apr 21, 2026",
    readTime: "5 min read",
    title: "Is Laser Hair Removal Safe? What to Expect",
    excerpt:
      "A clear, dermatologist-backed look at how modern laser systems work.",
    img: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=600&q=80",
  },
  {
    id: 3,
    date: "Apr 10, 2026",
    readTime: "3 min read",
    title: "Hydration: The Most Underrated Glow Hack",
    excerpt:
      "Why drinking water and using the right humectants changes your skin.",
    img: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600&q=80",
  },
  {
    id: 4,
    date: "Mar 28, 2026",
    readTime: "6 min read",
    title: "Understanding Pigmentation & How to Treat It",
    excerpt:
      "Dark spots, melasma, and sun damage — with the best clinical solutions.",
    img: "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=600&q=80",
  },
];

/* ── Main Component ── */
const CustomerBlog = () => {
  const navigate=useNavigate();
  const [loadingBtn, setLoadingBtn] = useState(null);

  const handleBtnClick = (key) => {
    setLoadingBtn(key);
    setTimeout(() => {
      setLoadingBtn(null);
    }, 800);
  };

  useEffect(()=>{
  checkLoggedInCustomer(Navigate);
  },[]);
  return (
    <Container fluid>
      {/* Page Title */}
      <h1 className="sgc-blog-title">Blog &amp; Skin Care Tips</h1>

      {/* CSS Grid — same as current working layout */}
      <div className="sgc-blog-grid">
        {blogPosts.map((post) => (
          <div className="sgc-blog-card" key={post.id}>

            {/* Image */}
            <div className="sgc-blog-card-img-wrap">
              <img
                src={post.img}
                alt={post.title}
                className="sgc-blog-card-img"
              />
            </div>

            {/* Body */}
            <div className="sgc-blog-card-body">
              <p className="sgc-blog-meta">
                {post.date} &nbsp;·&nbsp; {post.readTime}
              </p>
              <p className="sgc-blog-card-title">{post.title}</p>
              <p className="sgc-blog-card-excerpt">{post.excerpt}</p>

              <div className="sgc-blog-card-footer">
                <button
                  className="sgc-blog-btn-read"
                  disabled={loadingBtn === `${post.id}-read`}
                  onClick={() => handleBtnClick(`${post.id}-read`)}
                >
                  {loadingBtn === `${post.id}-read` ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : (
                    "Read"
                  )}
                </button>
                <button
                  className="sgc-blog-btn-save"
                  disabled={loadingBtn === `${post.id}-save`}
                  onClick={() => handleBtnClick(`${post.id}-save`)}
                >
                  {loadingBtn === `${post.id}-save` ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : (
                    <>
                      <SgcHeartIcon />
                      Save
                    </>
                  )}
                </button>
              </div>
            </div>

          </div>
        ))}
      </div>
    </Container>
  );
};

export default CustomerBlog;